module.exports = __webpack_public_path__ + "static/img/AllInOne7.ac5a74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne7.png
// module id = CbPY
// module chunks = 2